<template>
  <a-spin :spinning="isLoading">
    <a-auto-complete
      v-model="beforeSearchString"
      class="demo__Autocomplete demo__radius--4"
      :placeholder="placeholder"
      dropdownClassName="demo__Select--single-dropdown"
      :getPopupContainer="(triggerNode) => triggerNode.parentElement"
      @select="onSelectValue"
    >
      <template slot="dataSource">
        <a-select-option
          v-for="option in _results"
          :key="option.id"
          :value="option.name"
        >
          <template>
            {{ option.name }}
          </template>
        </a-select-option>
      </template>
    </a-auto-complete>
  </a-spin>
</template>

<script>
import Fuse from "fuse.js";

export default {
  props: {
    onSelect: {
      type: Function,
      required: false,
      default: () => {},
    },
    data: {
      type: Array,
      required: false,
      default: () => {},
    },
    placeholder: {
      type: String,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {
      beforeSearchString: undefined,
      searchQuery: undefined,
      printTimeout: undefined,
      isLoading: false, // Состояние загрузки
      rawResults: [], // Результаты поиска
      fuse: new Fuse(this.data, {
        keys: ["name"],
        includeScore: true, // Включаем оценку совпадения
        threshold: 0.3, // Порог для нечёткого поиска
        ignoreLocation: true, // Искать подстроку в любом месте строки
        findAllMatches: true, // Искать все совпадения в строке
      }),
    };
  },
  computed: {
    searchResults() {
      return this.rawResults;
    },
    _results() {
      return this.rawResults.length ? this.rawResults : this.data.slice(0, 20);
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(newData) {
        this.fuse = new Fuse(newData, {
          keys: ["name"], // Ищем по полю name
          includeScore: true,
          threshold: 0.3,
          ignoreLocation: true,
          findAllMatches: true,
        });
      },
    },
    beforeSearchString(val) {
      clearTimeout(this.printTimeout);
      this.printTimeout = setTimeout(() => {
        this.searchQuery = val;
      }, 500);
    },
    // Наблюдаем за изменением searchQuery
    searchQuery(newQuery) {
      this.performSearch(newQuery);
    },
  },
  created() {
    this.$accessModule("fuse", this);
  },
  methods: {
    // Асинхронный поиск
    async performSearch(query) {
      if (!!!query) {
        this.rawResults = [];
        return;
      }

      this.$debug("Выполняется поиск", "warning");

      this.isLoading = true;

      try {
        const results = this.fuse.search(query);

        // Фильтруем результаты, чтобы убедиться, что строка содержит подстроку
        this.rawResults = results.map((result) => result.item);
      } catch (error) {
        console.error("Ошибка при поиске:", error);
        this.rawResults = [];
      } finally {
        this.isLoading = false;
      }
    },
    onSelectValue(value) {
      const selected = this.data.find((item) => item.name === value);
      if (selected) this.onSelect(selected);
    },
  },
};
</script>
